import { render } from "./DisplaceEditView.vue?vue&type=template&id=f24f5c28&scoped=true"
import script from "./DisplaceEditView.vue?vue&type=script&lang=js"
export * from "./DisplaceEditView.vue?vue&type=script&lang=js"

import "./DisplaceEditView.vue?vue&type=style&index=0&id=f24f5c28&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24f5c28"]])

export default __exports__